import {Controller} from '@hotwired/stimulus';
import {useDebounce} from 'stimulus-use';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'promoCode',
        'promoCodeLabel',
        'promoCodeName',
        'promoCodeDesc',
        'promoCodeId',
        'promoForm',
        'promoCodeText',
    ];

    static values = {
        promoCodeUrl: String,
    };

    static debounces = ['onPromoCodeSubmit'];

    initialize() {
        useDebounce(this, {wait: 500});
    }

    togglePromoCode() {
        this.promoCodeTarget.classList.remove('hidden');
        this.promoCodeTextTarget.innerText = 'Enter Promo Code';
    }

    onClosePromoCode() {
        this.promoCodeTarget.classList.add('hidden');
        this.promoCodeTextTarget.innerText = 'Have a Promo Code?';
    }

    promoKeyup(e) {
        if (e.keyCode === 13) {
            this.onPromoCodeSubmit();
        }
    }

    async onPromoCodeSubmit() {
        const promoCodeInput = this.promoCodeTarget.querySelector('input');
        if (promoCodeInput.value === '') {
            window.showErrorMessage('You need to enter promo code before applying it');
            return;
        }

        const formData = new FormData();
        formData.append('code', promoCodeInput.value);

        await fetch(this.promoCodeUrlValue, {
            method: 'POST',
            body: formData,
        })
            .then((response) => {
                if (response.status !== 200) {
                    throw new Error();
                }

                return response.json();
            })
            .then((promotion) => {
                if (Object.keys(promotion).length > 0) {
                    this.promotion = promotion;
                    this.promoCodeNameTarget.innerHTML = this.promotion.name ? this.promotion.name : '';
                    this.promoCodeDescTarget.innerHTML = this.promotion.description ? this.promotion.description : '';
                    this.promoCodeIdTarget.value = this.promotion.id;
                    this.promoCodeIdTarget.disabled = false;
                    window.showSuccessMessage('Promo Code applied');
                    this.promoFormTarget.classList.add('hidden');
                    this.promoCodeLabelTarget.classList.remove('hidden');
                    this.onClosePromoCode();
                } else {
                    window.showErrorMessage('There was an error while applying promo code');
                }
            })
            .catch(() => {
                if (typeof this.promotion === 'object') {
                    window.showErrorMessage(
                        'There was an error applying new promo code. Old promo code is still active'
                    );
                } else {
                    window.showErrorMessage('Promo Code not found');
                }
            });
    }

    removePromoCode() {
        this.promoFormTarget.classList.remove('hidden');
        this.promoCodeLabelTarget.classList.add('hidden');
        this.promoCodeIdTarget.disabled = true;
        this.promotion = void 0;
    }
}
